"use strict";
exports.REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/May2025-PROD/prima/node_modules/ng-metadata/src/core/directives/controller/constants.js
// module id = 505
// module chunks = 6